/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowElbowLeftUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,192a8.00008,8.00008,0,0,1-8,8H80a8.00008,8.00008,0,0,1-8-8V104H32a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A8.00038,8.00038,0,0,1,128,104H88v80H224A8.00008,8.00008,0,0,1,232,192Z" />
    </Svg>
  );
}

export default ArrowElbowLeftUp;
